import { TextField, Button, Paper, Typography, Box, Alert } from "@mui/material";
import { useState, useEffect } from "react";
import axios from "axios";
import CompanyAutoselect from "../Universal/CompanyAutoselect";
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

function EditCompanies(props) {
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [editingCompany, setEditingCompany] = useState(null);
    const [companyName, setCompanyName] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const handleCompanySelect = (company) => {
        setSelectedCompany(company);
        setEditingCompany(company);
        setCompanyName(company.companyName);
        setIsEditing(false);
        setMessage({ type: '', text: '' });
    };

    const handleEdit = () => {
        setIsEditing(true);
        setMessage({ type: '', text: '' });
    };

    const handleCancel = () => {
        setIsEditing(false);
        setCompanyName(selectedCompany.companyName);
        setMessage({ type: '', text: '' });
    };

    const handleSave = () => {
        if (!companyName.trim()) {
            setMessage({ type: 'error', text: 'Company name cannot be empty' });
            return;
        }

        axios({
            url: process.env.REACT_APP_API_URL + 'Company',
            method: "PUT",
            data: {
                companyId: selectedCompany.companyId,
                companyName: companyName.trim()
            },
        }).then((res) => {
            // Update the company in the allCompanies list
            const updatedCompany = { ...selectedCompany, companyName: companyName.trim() };
            setSelectedCompany(updatedCompany);
            setEditingCompany(updatedCompany);
            setIsEditing(false);
            setMessage({ type: 'success', text: 'Company name updated successfully' });
            
            // Reload the companies list to ensure all components are updated
            if (props.refreshCompanies) {
                props.refreshCompanies();
            }
        }).catch((err) => {
            console.log(err);
            setMessage({ type: 'error', text: 'Failed to update company name' });
        });
    };

    return (
        <div className="container">
            <h4>Edit Company</h4>
            
            <div className="formRow">
                <div className="formGroup">
                    <CompanyAutoselect 
                        allCompanies={props.allCompanies} 
                        showAllCompanies={true} 
                        onChange={handleCompanySelect} 
                        selectText="Select Company" 
                        headerText=""
                    />
                </div>
            </div>

            {selectedCompany && (
                <Paper elevation={2} sx={{ p: 3, mt: 2 }}>
                    <Typography variant="h6" gutterBottom>
                        Company Details
                    </Typography>
                    
                    {message.text && (
                        <Alert severity={message.type} sx={{ mb: 2 }}>
                            {message.text}
                        </Alert>
                    )}

                    <div className="formRow">
                        <div className="formGroup">
                            <TextField
                                className="formControl"
                                label="Company Name"
                                variant="outlined"
                                value={companyName}
                                onChange={(e) => setCompanyName(e.target.value)}
                                disabled={!isEditing}
                                fullWidth
                            />
                        </div>
                    </div>

                    <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                        {!isEditing ? (
                            <Button 
                                variant="outlined" 
                                startIcon={<EditIcon />}
                                onClick={handleEdit}
                            >
                                Edit
                            </Button>
                        ) : (
                            <>
                                <Button 
                                    variant="contained" 
                                    startIcon={<SaveIcon />}
                                    onClick={handleSave}
                                >
                                    Save
                                </Button>
                                <Button 
                                    variant="outlined" 
                                    startIcon={<CancelIcon />}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Box>
                </Paper>
            )}
        </div>
    );
}

export default EditCompanies; 